module.exports = __webpack_public_path__ + "static/media/ZhiBo3.2a45e18e.png";